// Base64 encode/decode - compatible with the Addon's ImportExport.lua format

export function base64Encode(str) {
  try {
    return btoa(unescape(encodeURIComponent(str)));
  } catch {
    return btoa(str);
  }
}

export function base64Decode(str) {
  try {
    return decodeURIComponent(escape(atob(str.replace(/\s/g, ''))));
  } catch {
    try {
      return atob(str.replace(/\s/g, ''));
    } catch {
      return null;
    }
  }
}
